import React from 'react';
import { Link } from 'react-router-dom';

import styles from './BrowseResults.module.scss';

const BrowseEmpty = () => {
  return (
    <div className={styles.flexContainer}>
      <div className={styles.placeholderContainer}>
        <div className={styles.ctaContainer}>
          <div className={styles.ctaTitle}>No results</div>

          <div className={styles.ctaQuestion}>
            Adjust your filter and try again. Or let our freelancers pitch to
            you by <Link to="/post">posting a new project</Link>.
          </div>
        </div>

        <div className={styles.descriptionContainer}>
          <div className={styles.descriptionContent}>
            <strong>Can’t find what you need?</strong>
            <br />
            <br />
            To get the best freelancer for your project, you can upgrade to
            Twine Business and the Twine team will source and vet candidates for
            you.
          </div>

          <div className={styles.descriptionTitle}>
            <Link to="/enterprise" target="_blank">
              Learn more about Twine Business
            </Link>
            .
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrowseEmpty;
